import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface InjuryTypesServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<InjuryTypesServiceData>(db, 'injuryTypesService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
